import React from 'react';
import { useNavigate } from 'react-router-dom';
import { resources } from '../../constants';
import { useMrepState } from '../../helpers/mrepHelper';
import { calculateDelta, formatDecimals, formatNumber, formatNumberWithCommas, formatString, truncateEthereumAddress } from '../../utils';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import Tooltip from '../action/TooltipWrapper';
import { BlueBadge, GreenBadge, RedBadge } from '../Badge/Badge';
import Logo from '../Logo/Logo';
import TableSkeleton from '../TableContainer/TableSkeleton';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import './PaginatedTable.scss';

const PaginationTable = ({ data, itemsPerPage, handleVicinty, updatePositioningData, vicinity, lastRank, userRank }) => {
  const history = useNavigate();
  const [{ userData }] = useMrepState();

  const handleClick = userAddress => {
    history(`/profile/${userAddress}/projects`);
  };

  function changeVicinty(newPage) {
    if (!data) return;
    handleVicinty(newPage);
    updatePositioningData(newPage + itemsPerPage / 2);
  }

  function handleNext() {
    changeVicinty(+vicinity + itemsPerPage);
  }
  function handlePrevious() {
    changeVicinty(+vicinity - itemsPerPage);
  }
  function handleFirst() {
    changeVicinty(0);
  }
  function handleUser() {
    changeVicinty(+userRank - itemsPerPage / 2);
  }

  function handleDelta(row, key) {
    const value = Number(calculateDelta(Number(row?.rank), Number(row?.deltaRanks[key])));
    if (value > 0) {
      return <GreenBadge text={`${value}%`} />;
    } else if (value < 0) {
      return <RedBadge text={`${value}%`} />;
    } else {
      return '-';
    }
  }

  if (!data) return <TableSkeleton rows={10} />;

  return (
    <FlexboxColumn className='pagination_table' gap='0.75rem' fw>
      <FlexboxColumn className='pagination_table__table' gap='0'>
        <Flexbox className='pagination_table__table__header' fw>
          <div className='name'>
            <ThemedText.P weight={'semi-bold'}>Name</ThemedText.P>
          </div>
          <Flexbox className='contribution' justifyContent='flex-start' gap='0.5rem'>
            <ThemedText.P weight={'semi-bold'}>Contribution Rank</ThemedText.P>
            <Tooltip
              content={
                'Contribution Rank is calculated by considering your volume in this project across the tracked chains, and compared with other users in the same environment.'
              }
              position={'right'}
            >
              <ThemeLogo icon={'info'} />
            </Tooltip>
            {/* <ThemeLogo icon={'sort'} /> */}
          </Flexbox>
          <Flexbox className='contribution' justifyContent='flex-start' gap='0.5rem'>
            <ThemedText.P weight={'semi-bold'}>Volume</ThemedText.P>
            {/* <ThemeLogo icon={'sort'} /> */}
          </Flexbox>

          <Flexbox className='rank' justifyContent='flex-start' gap='0.5rem'>
            {' '}
            <ThemedText.P weight={'semi-bold'}>Rank Δ 7D</ThemedText.P>
            {/* <ThemeLogo icon={'sort'} /> */}
          </Flexbox>
          <Flexbox className='rank' justifyContent='flex-start' gap='0.5rem'>
            {' '}
            <ThemedText.P weight={'semi-bold'}>Rank Δ 30D</ThemedText.P>
            {/* <ThemeLogo icon={'sort'} /> */}
          </Flexbox>
          <div className='action'></div>
        </Flexbox>
        {data && data?.length === 0 && (
          <Flexbox className='table_container__row' fw>
            <ThemedText.H5>No data found </ThemedText.H5>
          </Flexbox>
        )}
        {data &&
          data.map(row => (
            <Flexbox
              className={`pagination_table__table__row ${userData?.address === row?.address && 'pagination_table__table__highlighted'}`}
              fw
              onClick={() => handleClick(row?.address)}
            >
              <Flexbox className='name' gap='0.5rem' justifyContent='flex-start'>
                <Logo width={'1.25rem'} height={'1.25rem'} borderRadius='50%' src={row?.avatarUrl ? row?.avatarUrl : resources.img.getAvatar(row?.address)} />
                <ThemedText.P> {row?.name ? formatString(row?.name) : truncateEthereumAddress(row?.address)}</ThemedText.P>
                {userData?.address === row?.address && <BlueBadge text={'User'} />}
              </Flexbox>
              {/* <div className='contribution'>
                <ThemedText.P> </ThemedText.P>
              </div> */}

              <Flexbox className='rank' justifyContent='flex-start' gap='0.25rem'>
                <ThemedText.P>{formatNumberWithCommas(row?.rank)} </ThemedText.P>
                {/* {row.rankDelta?.bps >= 0 ? <GreenBadge text={`+${row.rankDelta?.bps} bps`} /> : <RedBadge text={`-${row.rankDelta?.bps} bps`} />} */}
              </Flexbox>
              <Flexbox className='rank' justifyContent='flex-start' gap='0.25rem'>
                <ThemedText.P> ${formatNumber(formatDecimals(row?.volume))} </ThemedText.P>
              </Flexbox>
              <Flexbox className='rank' justifyContent='flex-start' gap='0.25rem'>
                <ThemedText.P>{handleDelta(row, '7d')} </ThemedText.P>
              </Flexbox>
              <Flexbox className='rank' justifyContent='flex-start' gap='0.25rem'>
                <ThemedText.P>{handleDelta(row, '30d')} </ThemedText.P>
              </Flexbox>
              <div className='action'>→</div>
            </Flexbox>
          ))}
      </FlexboxColumn>
      {data?.length > 0 && (
        <Flexbox className='pagination_table__controls' fw justifyContent='space-between'>
          <Flexbox gap='0.5rem'>
            <button disabled={!(vicinity > itemsPerPage)} onClick={handleFirst}>
              First
            </button>
            <button disabled={!(vicinity > itemsPerPage)} onClick={handlePrevious}>
              Prev
            </button>
          </Flexbox>
          <ThemedText.Span></ThemedText.Span>
          <Flexbox gap='0.5rem'>
            <button disabled={vicinity === userRank} onClick={handleUser}>
              My Rank
            </button>
            <button onClick={handleNext}>Next</button>
          </Flexbox>
        </Flexbox>
      )}
    </FlexboxColumn>
  );
};

export default PaginationTable;
